// @flow

import React, { Fragment } from "react";

import Common from "./Common";
import NameOrEmail from "src/containers/user/NameOrEmail";
import * as notifications from "src/constants/notifications";
import type { Message } from "src/types";

type Props = {
  message: Message,
};

const Member = ({ message }: Props) => {
  const { data, action } = message;
  const { members } = data;
  const userAction = action === notifications.MEMBER_ADD ? "added" : "removed";
  return (
    <Common {...message}>
      {" "}
      {userAction}{" "}
      {members.map((member, i) => (
        <Fragment key={member}>
          {i === members.length - 1 && members.length > 1 && " and "}
          <NameOrEmail
            uid={member}
            showPending={false}
            notificationVariant="common"
          />
          {i !== members.length - 2 &&
            i !== members.length - 1 &&
            members.length > 1 &&
            ", "}
        </Fragment>
      ))}
    </Common>
  );
};

export default Member;
